/**
 * Created by Workaxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Date: 17/08/23
 * Time: 10:46 am
 * Project: W-CRM-Frontend
 */
import React, {useEffect, useState} from "react";
import "./style.css";
import {useQuery} from "../utils/util";
import {useDispatch, useSelector} from "react-redux";
import {OrganizationState} from "../redux/Organization/organizationReducer";
import {ChangeClientLayoutState} from "../redux/profile/profileReducer";
import { useBrand } from "../context/BrandContext";

export default function ClientLayout({component: Component, ...rest}) {
    const urlQuery = useQuery();
    const dispatch = useDispatch()
    const brand = useBrand()
    const [isEmbed, setIsEmbed] = useState(false)
    const {clientLayoutOrg} = useSelector(OrganizationState);

    useEffect(() => {
        setIsEmbed(urlQuery.get("embed") != null)
    }, [urlQuery]);

    useEffect(() => {
        dispatch(ChangeClientLayoutState(true))
    }, [dispatch]);


    return (
        <>
            {isEmbed ?
                <div className={"embed-holder"} id={"brand-crm-iframe"}>
                    <Component {...rest} />
                </div> :
                <div className={"clientLayout-container"}>
                    <div className={"clientLayout-child-holder"}>
                        <div className={"clientLayout-holder"} id={"brand-crm-iframe"}>
                            <Component {...rest} />
                        </div>
                    </div>

                    {clientLayoutOrg &&
                        <>
                            <div className={"clientLayout-header-holder"}>
                                {clientLayoutOrg?.data?.profile_pic && <img
                                    alt={clientLayoutOrg?.data?.name}
                                    src={clientLayoutOrg?.data?.profile_pic}
                                />}
                            </div>


                            {brand?.ui?.show_copyright !== false && (
                                <div className={"clientLayout-footer-holder"}>
                                    <small>{clientLayoutOrg?.data?.name || brand?.app_name}</small>
                                </div>
                            )}
                        </>
                        
                    }
                </div>
            }
        </>
    );
}
